const a = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789 "{}:()=+';
const b = 'fD2Pq9H czTE4NQ7m)nhVyOiU8sR0wtkS"GbjI:KCYg3xv=o{Wl+X(J6LuAdM1ae}5BrpFZ';


export default class BasicCryp
{

    public static Encode(data : string)
    {
        let result = '';

        for(let c = 0; c < data.length; c++)
        {
            let inA = a.indexOf(data[c]);

            if(inA == -1)
                result += data[c];
            else
                result += b[inA];
        }

        return result;
    }

    public static Decode(hash : string)
    {
       let result = '';

        for(let c = 0; c < hash.length; c++)
        {
            let inB = b.indexOf(hash[c]);

            if(inB == -1)
                result += hash[c];
            else
                result += a[inB];
        }

        return result;
    }

}



